import { render, staticRenderFns } from "./vacancyCandidatePlacing.vue?vue&type=template&id=77ee10dc&"
import script from "./vacancyCandidatePlacing.vue?vue&type=script&lang=js&"
export * from "./vacancyCandidatePlacing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports